import {
  List,
  Datagrid,
  TextField,
  ResourceComponentProps,
  TextInput,
  Show,
  SimpleShowLayout,
} from "react-admin";

const CategoryListFilters = [
  <TextInput source="id" />,
  <TextInput source="name" />,
];

export const CategoryList = (props: ResourceComponentProps) => (
  <List {...props} bulkActionButtons={false} filters={CategoryListFilters}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="name" />
    </Datagrid>
  </List>
);


export const CategoryShow = (props: ResourceComponentProps) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="salesforceId" />
      <TextField source="name" />
    </SimpleShowLayout>
  </Show>
);

